import React from 'react';
import { Outlet } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ThemeToggle } from '@/components/theme-toggle';
import { Breadcrumbs } from '@/components/navigation';
import { useAuth } from '@/components/auth';
import { Footer } from './Footer';
import { LogOut } from 'lucide-react';

export function AppLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="overflow-x-hidden">
      {/* Main content container - takes full viewport height */}
      <div className="min-h-screen flex flex-col justify-center items-center relative">
        {/* Theme toggle and logout in top right corner */}
        <div className="absolute top-4 right-4 flex gap-2 z-20">
          <ThemeToggle />
          {user && (
            <Button variant="outline" size="icon" onClick={logout} title="Sign Out">
              <LogOut className="h-4 w-4" />
            </Button>
          )}
        </div>

        {/* Centered main content */}
        <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8 text-center relative z-10">
          <Breadcrumbs />
          <Outlet />
        </div>
      </div>
      
      {/* Footer positioned below the viewport */}
      <Footer />
    </div>
  );
}